var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbcCodingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17309_1380)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7375 1.44043C11.7375 3.44238 11.7375 5.44434 11.7375 7.44629C11.7375 7.47886 11.7375 7.51138 11.7375 7.54395C11.2634 8.46162 10.8378 9.40562 10.4607 10.376C10.5284 11.0391 10.8628 11.2751 11.4639 11.084C11.5605 11.0328 11.6365 10.9595 11.6919 10.8643C11.7374 12.3696 11.7526 13.8833 11.7375 15.4053C7.95261 15.4053 4.16771 15.4053 0.382812 15.4053C0.382812 11.1572 0.382812 6.90918 0.382812 2.66113C0.556526 2.04387 0.936534 1.6451 1.52284 1.46484C4.9277 1.44043 8.3326 1.43229 11.7375 1.44043Z",
    fill: "#F1F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.737 1.44043C15.3547 1.43229 18.9724 1.44043 22.5901 1.46484C23.1764 1.6451 23.5564 2.04387 23.7301 2.66113C23.7301 6.90918 23.7301 11.1572 23.7301 15.4053C19.7324 15.4053 15.7347 15.4053 11.737 15.4053C11.7521 13.8833 11.7369 12.3696 11.6914 10.8643C11.7218 10.8154 11.7522 10.7666 11.7826 10.7178C12.3824 9.43325 12.9828 8.14746 13.5839 6.86035C13.7443 6.10435 13.4631 5.7544 12.7402 5.81055C12.6006 5.86235 12.4866 5.95186 12.3982 6.0791C12.1881 6.54551 11.9677 7.00122 11.737 7.44629C11.737 5.44434 11.737 3.44238 11.737 1.44043Z",
    fill: "#F1F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18072 5.78613C8.69455 5.72646 8.99857 5.9625 9.09274 6.49414C9.08243 6.64121 9.04445 6.77954 8.97874 6.90918C8.49167 7.42256 8.01286 7.94341 7.5423 8.47168C8.01286 8.99995 8.49167 9.5208 8.97874 10.0342C9.19739 10.6725 8.99219 11.0468 8.36312 11.1572C8.22937 11.1589 8.10775 11.1182 7.99831 11.0352C7.33709 10.3271 6.67588 9.61914 6.01466 8.91113C5.86491 8.61499 5.86491 8.32202 6.01466 8.03222C6.71806 7.25454 7.44006 6.50581 8.18072 5.78613Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7856 10.7178C11.7401 9.66826 11.7249 8.61035 11.74 7.54394C11.74 7.51137 11.74 7.47885 11.74 7.44628C11.9707 7.00121 12.1911 6.5455 12.4012 6.0791C12.4896 5.95185 12.6036 5.86235 12.7432 5.81054C13.4661 5.75439 13.7473 6.10434 13.5869 6.86035C12.9858 8.14746 12.3854 9.43325 11.7856 10.7178Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4786 5.78615C15.7026 5.76481 15.9153 5.80548 16.117 5.90822C16.8251 6.65016 17.5168 7.407 18.1918 8.17872C18.2405 8.43595 18.2101 8.68009 18.1006 8.91115C17.4394 9.61915 16.7782 10.3272 16.117 11.0352C15.6068 11.2786 15.2496 11.124 15.0454 10.5713C15.0038 10.3783 15.0342 10.1993 15.1366 10.0342C15.6236 9.52081 16.1024 8.99996 16.573 8.47169C16.0707 7.9257 15.5767 7.37233 15.091 6.81154C14.9682 6.35856 15.0974 6.01676 15.4786 5.78615Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7378 7.54395C11.7227 8.61035 11.7379 9.66826 11.7834 10.7178C11.753 10.7666 11.7226 10.8154 11.6922 10.8643C11.6367 10.9595 11.5607 11.0328 11.4642 11.084C10.8631 11.2751 10.5287 11.0391 10.4609 10.376C10.8381 9.40562 11.2637 8.46162 11.7378 7.54395Z",
    fill: "#646A79"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.382812 15.4053C4.16771 15.4053 7.95261 15.4053 11.7375 15.4053C15.7352 15.4053 19.7329 15.4053 23.7306 15.4053C23.7306 15.4215 23.7306 15.4378 23.7306 15.4541C19.7329 15.4541 15.7352 15.4541 11.7375 15.4541C11.7375 16.6748 11.7375 17.8955 11.7375 19.1162C10.7951 19.1162 9.85267 19.1162 8.91023 19.1162C6.47814 19.1244 4.04606 19.1162 1.61404 19.0918C0.975993 18.9535 0.565583 18.5548 0.382812 17.8955C0.382812 17.0654 0.382812 16.2354 0.382812 15.4053Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7314 15.4541C23.7314 16.2679 23.7314 17.0817 23.7314 17.8955C23.5365 18.5387 23.1261 18.9375 22.5002 19.0918C20.0682 19.1162 17.6361 19.1244 15.204 19.1162C14.0488 19.1162 12.8935 19.1162 11.7383 19.1162C11.7383 17.8955 11.7383 16.6748 11.7383 15.4541C15.736 15.4541 19.7337 15.4541 23.7314 15.4541Z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91202 19.1162C9.85446 19.1162 10.7969 19.1162 11.7393 19.1162C11.7393 20.0928 11.7393 21.0693 11.7393 22.0459C10.485 22.0621 9.23862 22.0458 8 21.9971C8.30402 21.0368 8.608 20.0765 8.91202 19.1162Z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7383 19.1162C12.8935 19.1162 14.0488 19.1162 15.204 19.1162C15.508 20.0765 15.812 21.0368 16.116 21.9971C14.6646 22.0458 13.2053 22.0621 11.7383 22.0459C11.7383 21.0693 11.7383 20.0928 11.7383 19.1162Z",
    fill: "#424A53"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9996 21.9971C9.23822 22.0458 10.4846 22.0621 11.7389 22.0459C11.7389 22.5342 11.7389 23.0225 11.7389 23.5107C9.92999 23.5189 8.12112 23.5107 6.31235 23.4863C5.8609 23.2241 5.7469 22.8417 5.97034 22.3389C6.0838 22.1521 6.2434 22.0463 6.44916 22.0215C6.96573 21.9971 7.48257 21.9889 7.9996 21.9971Z",
    fill: "#626877"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.116 21.9971C16.633 21.9889 17.1499 21.9971 17.6664 22.0215C18.2235 22.2311 18.3831 22.6299 18.1452 23.2178C18.0569 23.345 17.9429 23.4345 17.8032 23.4863C15.7816 23.5107 13.76 23.5189 11.7383 23.5107C11.7383 23.0225 11.7383 22.5342 11.7383 22.0459C13.2053 22.0621 14.6646 22.0458 16.116 21.9971Z",
    fill: "#656B79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17309_1380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3478,
    height: 25,
    fill: "white",
    transform: "translate(0.40625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbcCodingIcon);
export default __webpack_public_path__ + "static/media/cbc-coding-icon.f505d09224170a256479fc9ede612723.svg";
export { ForwardRef as ReactComponent };